import React from "react";

function WhyCEthereum() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Why Choose Ethereum for Your Blockchain Project?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  Ethereum is the pioneer of smart contract platforms, offering
                  unmatched flexibility and security for developing
                  decentralized applications (DApps). With a vast developer
                  community, high interoperability, and a strong foundation in
                  decentralized finance (DeFi) and NFT ecosystems, Ethereum
                  remains the top choice for businesses entering the blockchain
                  space.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhyCEthereum;
